import { getJson, putJson, deleteJson, withDone, withValidate, withOptional } from '@rad/utility/http';
export const getUsers = (p) => getJson(`/api/user/all`, p);
export const getUser = (id) => withOptional(getJson(`/api/user/${id}`));
export const updateUserRoles = (userId, roles) => withDone(withValidate(putJson(`/api/user/${userId}/roles`, { roles })))();
export const updateProfile = (data) => withDone(withValidate(putJson(`/api/user/profile`, data)))();
export const deleteProfile = () => withDone(deleteJson(`/api/user/profile`))();
export const getUserProperties = (id) => withOptional(getJson(`/api/user/${id}/properties`));
export const getEmailPreferences = () => getJson(`/api/user/email-preferences`);
export const updateEmailPreferences = (preferences) => withDone(putJson(`/api/user/email-preferences`, { preferences }))();
